pageId = 'page-project-members'
page = "##{ pageId }"

$ ->
  $(document).on 'ajax:beforeSend', "#{ page} form#form-members", (e, xhr, settings) ->
    # set ajax param members
    membersGuid = $('.member.selected:not(.invited)').map ->
      $(@).data 'guid'
    .get()

    invitations = $('.member.invited.selected').map ->
      $(@).data 'guid'
    .get()

    settings.data += '&members=' + membersGuid.join(',') + '&invitations=' + invitations.join(',')

  .on 'ajax:success', "#{ page} form#form-members", (e, result) ->
    # make sure the project members should be updated
    projGuid = $('button[type=submit]', e.target).data('project-guid')
    delete tower.members[projGuid]  if projGuid and tower.members
    if location.search.indexOf('edit=true') > -1
      tower.stack.load location.pathname.replace('/members', ''),
        noCache: true
        replace: true
        root: true
    else
      tower.stack.load location.href,
        noCache: true
        replace: true

  .on 'click', "#{page} .link-edit-members", (e) ->
    $(@).toggleClass('active')
    $('.project-members, #form-members').toggleClass('hide')
  .on 'click', "#{page} .edit-members-button", ->
    $(page).addClass('editing')
    $('.project-members, #form-members').toggleClass('hide')
  .on 'click', "#{page} .cancel-save-members-button", ->
    $(page).removeClass('editing')
    $('.project-members, #form-members').toggleClass('hide')

  tower.stack.on "pageunload", (e, $page, pageParams) ->
    if $page.is(page)
      $link = $page.find('.link-edit-members')
      $link.trigger('click')  if $link.hasClass('active')

      if location.search.indexOf('edit=true') == -1
        if $page.hasClass('editing')
          $page.removeClass('editing')
          $('.project-members, #form-members').toggleClass('hide')
      else
        if !$page.hasClass('editing')
          $page.addClass('editing')
          $('.project-members, #form-members').toggleClass('hide')

    return e.result

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $form = $page.find('#form-members')

  tower.memberChangeLogs()
  tower.initManageMembers $page
  tower.initManageMembersTabs $page.find('.manage-members-tabs')
  tower.fetchQrcode()

  unless $form.find('.members').length
    $form.find('.link-show-invite').hide()
      .nextAll('.form-item').show()

  if $page.is('[data-deleted]')
    $page.find('.link-edit-members, .edit-members-button').remove()
    $form.remove()

  $('.manage-members-tabs').on 'click', '[data-tab]', (e) ->
    $tab = $ e.target
    tab = $tab.data('tab')

    if ['email', 'wechat', 'link'].indexOf(tab) != -1
      # 业务解释：如果点击了「邮件邀请」「微信邀请」，如果需要，显示「你仍可以继续邀请，但」弹窗。
      if $("[data-trial-surpass-members-limit='true']").length > 0
        # 为了避免弹窗太频繁，只弹一次，用户下次进入此页面之后重置状态。
        $("[data-trial-surpass-members-limit='true']").remove()
        tower.showTrialTeamSurpassMembersLimit()

    if ['wechat', 'link'].indexOf(tab) != -1
      $form.find('.form-buttons').hide()
    else
      $form.find('.form-buttons').show()

  $('.link-edit-members').trigger('click') if location.search.indexOf('edit=true') > -1
